import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMapPin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMapPin"><Path d="M14.4978 10C14.4978 11.3807 13.3785 12.5 11.9978 12.5C10.6171 12.5 9.4978 11.3807 9.4978 10C9.4978 8.61929 10.6171 7.5 11.9978 7.5C13.3785 7.5 14.4978 8.61929 14.4978 10Z" stroke="currentColor"/><Path d="M19.5 10C19.5 16.1919 12 21.5 12 21.5C12 21.5 4.5 16.1919 4.5 10C4.5 5.75 7.85786 2.5 12 2.5C16.1421 2.5 19.5 5.75 19.5 10Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconMapPin;
